import styled from "styled-components";
import {BounceLoader} from 'react-spinners';

const Backdrop = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #FFFFFFCC;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000000;
`;

export function Loading() {
    return <Backdrop>
        <BounceLoader color={"black"} size={80} />
    </Backdrop>;
}
